import repository from '@/repositories/Repository'

const resource = '/api/query_metadata'

export default {
  getOutputColumns() {
    return repository.mouse.get(`${resource}/output_columns`).then(r => r.data)
  },
}
